export default __webpack_public_path__ + "static/media/Pilz-Button-Essbar.fc538719.png";